<app-tab-view (onSelect)="onTabChange($event)" [tabIndex]="0"
              [tabHeadersIcons]="tabHeadersIcons" [tabHeaders]="tabHeaders"></app-tab-view>

<br>
<div *ngIf="selectedTabName === 'General'">
  <app-general-tab></app-general-tab>
</div>

<div *ngIf="selectedTabName === 'Emailing'">
  <app-emailing-tab></app-emailing-tab>
</div>
